export default __webpack_public_path__ + "static/ryan-banner-2968c3f691fdf6e2d66cd05d88f032d3.jpg";